import { render } from "./buscadorserviciosmenu.vue?vue&type=template&id=7f1d8c1a"
import script from "./buscadorserviciosmenu.vue?vue&type=script&lang=js"
export * from "./buscadorserviciosmenu.vue?vue&type=script&lang=js"

import "./buscadorserviciosmenu.vue?vue&type=style&index=0&id=7f1d8c1a&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__